<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Salary Structure List"
                btnTitle="Add Pay Head"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>

        <div class="my-2 px-2">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="col-form-label">Employee: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
            </div>

            <AsyncSelect
                placeholder="Select Employee"
                v-model="contactProfile"
                :api-service="fetchContactProfiles"
                :additional-query="additionalContactOption"
            />
          </div>
          <div class="col-2 d-flex align-items-end">
            <button
                style="min-width: 64px;"
                @click="getSalaryStructureEmployee"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Go
            </button>
          </div>
        </div>

        <div class="col-12">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="onClickToExport"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Export
            </button>
          </div>
        </div>
      </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Employee ID</th>
                  <th>Employee Name</th>
                  <th>Salary Type</th>
                  <th>Payscale</th>
                  <th v-for="(item, i) in grossComponentPayHead" :key="i">{{ item.name }}</th>
                  <th>Gross Salary</th>
                  <th v-for="(item, i) in payHeads" :key="i">{{ item.name }}</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td>{{ item.serial_no }}</td>
                  <td>{{ item.full_name }}</td>
                  <td>{{ item.salary_type_name }}</td>
                  <td></td>
                  <td class="text-right" v-for="gh in grossComponentPayHead" :key="gh.id">
                    {{ commaFormat(item.gross_components[gh.id] || 0) }}
                  </td>
                  <td class="text-right">{{ item.gross_total }}</td>
                  <td class="text-right" v-for="ph in payHeads" :key="ph.id">
                    {{ commaFormat(item.other_components[ph.id] || 0) }}
                  </td>
                  <td class="text-center">
                    <button class="btn btn-primary btn-sm"
                            @click="openAddEditModal(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems && tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

        <AddSalaryStructureModal
            v-if="store.state.isModalOpenTwo"
            :formData="formData"
            :salaryStructureData="salaryStructureData"
            :salaryStructureGradeData="salaryStructureGradeData"
            @submitted="handleSalaryStructureSubmit"
        />
      <ContactDropdownFilter
          v-if="store.state.isModalOpenThree"
          @onSearchContact="onSearchContact"
          :companyRoles="companyRoles"
          :isFilterable="true"
          :roleSlug="'employee'"
      />

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import AddSalaryStructureModal from "@/components/molecule/company/hrm-payroll/salary-structures/AddSalaryStructureModal";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import handleRole from "@/services/modules/role";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import figureFormatter from "@/services/utils/figureFormatter";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const grossComponentPayHead = ref([]);
const payHeads = ref([]);
let contactProfile = ref(null)
const salaryStructureData = ref([]);
const salaryStructureGradeData = ref({
  grade_number: null,
  grade_serial: null,
  scale_amount: null,
  scale_id: null,
});
const params = ref({
    offset: 20,
});
const companyRoles = ref(null);
const additionalDealerQuery = ref({});
const additionalContactOption = ref({
  roles: 'employee',
  status: 'active'
});
const { commaFormat } = figureFormatter();
const formData = ref({
  contact_profile_id: null,
  effective_date: null,
  salary_type: null,
  salary_grade_scale_id: null,
  pay_heads:[]
})

const token = computed(() => localStorage.getItem('token'));

const getCompanyRoles = async () => {
  const res = await fetchCompanyDefaultRoles(`?company_id=${route.params.companyId}&roles=employee`);
  if (res.status) {
    companyRoles.value = res.data
  }
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
  contactProfile.value = contact
}

const handleSalaryStructureSubmit = () => {
  getSalaryStructureEmployee()
};

const {
  fetchPayHead,
  fetchSalaryStructure,
  getEmployeeSalaryStructure
} = handleHrPayroll()
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchContactProfiles } = handleContact();
function onClickAddNewButton() {
  router.push({name: `pay-head-add`, params: route.params, query: route.query})
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const openAddEditModal = (item) => {
  formData.value.contact_profile_id = item.id
  let query = getQuery()
  query += '&contact_profile_id=' + item.id
  salaryStructureData.value = []
  getEmployeeSalaryStructure(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data[0]
    formData.value.effective_date = data.effective_date;
    formData.value.salary_type = data.salary_type
    formData.value.salary_grade_scale_id = data.salary_grade_scale_id;
    formData.value.is_edit = true;
    salaryStructureGradeData.value.grade_number = data.grade_number;
    salaryStructureGradeData.value.grade_serial = data.grade_serial;
    salaryStructureGradeData.value.scale_amount = data.scale_amount;
    salaryStructureGradeData.value.scale_id = data.salary_grade_scale_id;

    salaryStructureData.value = res.data;
  });

  store.state.isModalOpenTwo = true
}

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getSalaryStructureEmployee();
}

const getSalaryStructureEmployee = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []

  await fetchSalaryStructure(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    tableItems.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getGrossComponentPayHead = async () => {
    let query = getQuery();
    query += '&gross_salary_component=1&is_all=1&income_type=fixed&payroll_category=salary,bonus,overtime,other_allowance';
    grossComponentPayHead.value = []

    await fetchPayHead(query).then(res => {
        if (!res.status){
            return
        }

      grossComponentPayHead.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getPayHead = async () => {
  let query = getQuery();
  query += '&gross_salary_component=0&is_all=1&income_type=fixed&payroll_category=salary,bonus,overtime,other_allowance';
  payHeads.value = []

  await fetchPayHead(query).then(res => {
    if (!res.status){
      return
    }

    payHeads.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (contactProfile.value) query += '&contact_profile_id=' + contactProfile.value.id;
    query += '&offset=' + params.value.offset
    return query;
}

const onClickToExport = () => {
  let token = localStorage.getItem('token');
  let url = `${process.env.VUE_APP_BASE_URL}/api/hr-payroll/salary-structures${getQuery()}&_token=${token}&is_export=1&is_all=1`;
  let a = document.createElement("a")
  a.setAttribute("href", url)
  a.click()
}

onMounted(() => {
    Promise.all([
      getGrossComponentPayHead(),
      getPayHead(),
      getSalaryStructureEmployee(),
      getCompanyRoles()
    ])
})
</script>
